<template>
  <el-row class="userheder">
    <el-col>
      <el-form
        :inline="true"
        :model="formSearch"
        ref="formSearch"
        class="demo-form-inline"
      >
        <el-col class="date">
          <el-form-item>
            <el-date-picker
              v-model="formSearch.formdate"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              style="width: 270px"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <product-select
              :value.sync="formSearch.afid"
              placeholder="请选择产品"
              @change="handerAfid"
              :isDefault="true"
              popper-class="BI-select BI-select-product"
            >
            </product-select>
          </el-form-item>
          <!-- </el-col>
        <el-col> -->
          <el-form-item>
            <el-select v-model="formSearch.dimension" placeholder="维度">
              <el-option label="时间" value="1"></el-option>
              <el-option label="地区" value="2"></el-option>
              <el-option label="渠道" value="3"></el-option>
              <el-option label="campaign" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="formSearch.mediaList"
              placeholder="渠道"
              multiple
              collapse-tags
              @change="changeSelect"
              class="multipleselect"
              ref="chnlref"
              popper-class="app-select-self"
            >
              <div class="input-search">
                <el-input
                  v-model="text"
                  size="mini"
                  suffix-icon="el-icon-search"
                />
              </div>
              <!-- <div slot="empty">
                <div class="input-search">
                  <el-input
                    v-model="text"
                    size="mini"
                    suffix-icon="el-icon-search"
                  />
                </div>
                <el-checkbox
                  v-model="checked"
                  @change="selectAll($event, 'check')"
                  >全选</el-checkbox
                >
              </div> -->
              <el-checkbox
                v-model="checked"
                @change="selectAll($event, 'check')"
                >全选</el-checkbox
              >
              <!-- v-for="item in mediaList" -->
              <div @click="clickclear" class="clearbutton">
                <span style="font-size: 14px">清空</span>
              </div>

              <el-option
                v-for="item in mediaList.filter(
                  (i) => !text || i.toLowerCase().includes(text.toLowerCase())
                )"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <areaMultiSelect
              :value.sync="formSearch.geoList"
              :optionsList="countryList"
            >
            </areaMultiSelect>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="formSearch.campaignList"
              multiple
              filterable
              placeholder="campaign"
              popper-class="BI-select BI-select-geo"
            >
              <el-option
                v-for="item in campaignOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="formSearch.dataType"
              placeholder="数据类型"
              popper-class="BI-select BI-select-geo"
            >
              <el-option label="变现" :value="2"></el-option>
              <el-option label="内购" :value="3"></el-option>
              <el-option label="变现+内购" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('formSearch')"
              >查询</el-button
            >
          </el-form-item>
        </el-col>
      </el-form>
    </el-col>
    <!-- <el-col :span="8" class="headerleft">
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <i class="el-icon-refresh" @click="onSubmit('formSearch')" />
      </el-tooltip>
    </el-col> -->
  </el-row>
</template>
<script>
import { changeshortcutclass, clearallshortcutclass } from "@/utils/tool";
import { getCampaignList } from "@/api/api";
import areaMultiSelect from "@/components/areaMultiSelect.vue";

import moment from "moment";
// import Axios from "axios";
export default {
  components: {
    areaMultiSelect,
  },
  computed: {
    mediaList: function () {
      return this.$store.state.Summary.mediaList;
    },
  },
  mounted: function () {
    const timer = setInterval(() => {
      if (this.formSearch.afid) {
        clearInterval(timer);
        this.$store.dispatch("getCountryListAndMedia", {
          afid: this.formSearch.afid,
          cb: (result) => {
            this.countryList = result.countryList;
            const {
              dimension,
              geoList,
              afid,
              formdate,
              mediaList,
              campaignList,
              dataType,
            } = this.formSearch;
            let param = {
              dateStart: moment(formdate[0]).format("YYYYMMDD"),
              dateEnd: moment(formdate[1]).format("YYYYMMDD"),
              afid,
              geoList,
              dimension,
              mediaList,
              campaignList,
              dataType,
            };
            const limit =
              Math.floor((new Date() - formdate[0]) / 1000 / 60 / 60 / 24) + 1;
            const limitDays = limit > 30 ? 30 : limit;
            this.$emit("refreshTable", { ...param, limitDays });
            // this.$store.dispatch("getSummaryList", {
            //   param,
            //   cb: () => {
            //     this.$emit("showLoading", false);
            //     this.$emit("refreshTable");
            //   },
            // });
          },
        });
      }
    }, 200);
    this.getCampaignList();
  },
  data() {
    return {
      countryList: [],
      campaignOptions: [],
      checked: false,
      text: "",
      formSearch: {
        formdate: [
          new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
          new Date(),
        ],
        afid: null,
        geoList: [],
        dimension: "1",
        campaignList: [],
        mediaList: [],
        dataType: 2,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "当天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("当天", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一周", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近一个月", picker.$el);
              }, 0);
            },
          },
          {
            text: "最近2个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
              picker.$emit("pick", [start, end]);
              setTimeout(() => {
                changeshortcutclass("最近2个月", picker.$el);
              }, 0);
            },
          },
        ],
        onPick: function ({ maxDate, minDate }) {
          clearallshortcutclass(this.$el);
          console.log(maxDate, minDate);
        },
        disabledDate: function (date) {
          if (new Date().getTime() - date.getTime() > 0) {
            return false;
          }
          return true;
        },
        // disabledDate: function(time) {
        //   return time.getTime() > Date.now();
        // }
      },
      value1: "",
      value2: "",
    };
  },
  methods: {
    clickclear() {
      console.log(this.$refs.chnlref);
      // this.$refs.chnlref.value = [];
      this.formSearch.mediaList = [];
    },

    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const {
            dimension,
            geoList,
            afid,
            formdate,
            mediaList,
            campaignList,
            dataType,
          } = this.formSearch;
          let param = {
            dateStart: moment(formdate[0]).format("YYYYMMDD"),
            dateEnd: moment(formdate[1]).format("YYYYMMDD"),
            afid,
            geoList,
            dimension,
            mediaList,
            campaignList,
            dataType,
          };
          const limit =
            Math.floor((new Date() - formdate[0]) / 1000 / 60 / 60 / 24) + 1;
          const limitDays = limit > 30 ? 30 : limit;
          this.$emit("refreshTable", { ...param, limitDays });
        } else {
          return false;
        }
      });
    },
    changeSelect(value) {
      if (
        this.checked &&
        this.formSearch.mediaList.length <
          this.$store.state.Summary.mediaList.length
      ) {
        this.checked = false;
        this.formSearch.mediaList = value;
      }
    },
    selectAll(event, value) {
      if (event) {
        this.formSearch.mediaList = this.$store.state.Summary.mediaList;
      } else {
        value == "check" ? (this.formSearch.mediaList = []) : null;
      }
    },
    handerAfid(e) {
      this.formSearch.geoList = [];
      this.$store.dispatch("getCountryList", {
        afid: e,
        cb: (result) => {
          this.countryList = result;
        },
      });
    },
    getCampaignList() {
      getCampaignList().then((res) => {
        this.campaignOptions = res.data;
      });
    },
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
@borderline: #e6e6e6;
.el-date-editor--daterange {
  width: 483px;
}
.el-button {
  margin-left: 14px;
  margin-right: 20px;
}
.userheder {
  border-radius: 3px;
  align-items: baseline;
  display: flex;
  min-width: 1200px;
}
.headerleft {
  text-align: right;
  i {
    font-size: 20px;
    margin-right: 10px;
    cursor: pointer;
  }
  i:hover {
    color: #409eff;
  }
}
.el-form-item {
  margin-bottom: 0px;
}
.date {
  // margin-bottom: 10px;
  /deep/ .el-range-separator {
    line-height: 25px;
  }
  /deep/ .el-range__icon {
    line-height: 25px;
  }
}
.el-checkbox {
  width: 95%;
  text-align: right;
}
.button {
  color: #fff;
  background-color: #5cb85c;
  border-color: #4cae4c;
  border-radius: 4px;
  line-height: 0.5;

  &:hover {
    background-color: #449d44;
    border-color: #398439;
  }
}
.selectedbutton {
  color: rgb(255, 255, 255) !important;
  background-color: red !important;
  border-color: rgb(76, 174, 76) !important;
}
.multipleselect ::v-deep .el-input__inner {
  // &::placeholder {
  //   color: #777777 !important;
  // }
}
.input-search {
  width: 90%;
  margin-left: 5%;
}
.clearbutton {
  display: flex;
  // justify-content: center;
  padding: 0 20px;
  height: 34px;
  line-height: 34px;
  box-sizing: border-box;

  &:hover {
    background: #f5f7fa;
    cursor: pointer;
  }
}
</style>
